import React from "react";

function ModuleList({ title, items = [] }) {
  if (!items.length) return null;

  return (
    <div style={{ marginBottom: "40px" }}>
      {/* Heading */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "25px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: "700",
            color: "#5a140c",
          }}
        >
          {title}
        </h2>

        <div
          style={{
            background: "#5a140c",
            color: "#fff",
            padding: "10px 14px",
            borderRadius: "30px",
            fontWeight: "600",
            fontSize: "12px",
          }}
        >
          {items.length} Modules
        </div>
      </div>

      {/* Module Cards */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(420px,1fr))",
          gap: "22px",
        }}
      >
        {items.map((module, index) => {
          const moduleName =
            typeof module === "string"
              ? module
              : module?.moduleName || "Module";

          const description =
            typeof module === "string"
              ? ""
              : module?.description || "";

          return (
            <div
              key={index}
              style={{
                background: "#fff",
                border: "1px solid #ece7e5",
                borderRadius: "18px",
                padding: "24px",
                boxShadow: "0 6px 20px rgba(0,0,0,.05)",
              }}
            >
              {/* Module Heading */}

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "15px",
                }}
              >
                <div
                  style={{
                    minWidth: "35px",
                    width: "27px",
                    height: "31px",
                    borderRadius: "50%",
                    background: "#5a140c",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "18px",
                  }}
                >
                  ✓
                </div>

                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: "17px",
                      fontWeight: "700",
                      color: "#5a140c",
                      marginBottom: description ? "12px" : 0,
                    }}
                  >
                    {moduleName}
                  </div>

                  {description && (
                    <div
                      style={{
                        color: "#555",
                        fontSize: "15px",
                        lineHeight: "28px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {description}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ModuleList;